import { StyleObject } from '@styles-api/css.types'

export const importInput__nativeInputStyles: StyleObject = {
  height: 0,
  width: 0,
  opacity: 0,
  display: 'none',
}

export const importInput__labelStyles: StyleObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minHeight: '200px',
  padding: 'var(--surfacePadding)',
  border: '2px dashed var(--borderColor)',
  transition: 'var(--hoverTransition)',
  cursor: 'pointer',
  borderRadius: 'var(--radius2)',
  ':hover': {
    background: 'var(--shade100)',
  },
}

export const importInput__successContainerStyles: StyleObject = {
  border: '2px solid #28a745',
  borderRadius: '8px',
  padding: '20px',
  backgroundColor: '#f8fff9',
}

export const importInput__fileNameStyles: StyleObject = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333',
  display: 'block',
}

export const importInput__fileInfoStyles: StyleObject = {
  fontSize: '12px',
  color: '#666',
  display: 'block',
}

export const importInput__dropZoneStyles: StyleObject = {
  borderRadius: '8px',
  textAlign: 'center',
  transition: 'all 0.2s ease-in-out',
  position: 'relative',
  overflow: 'hidden',
}

export const importInput__dropZoneNormalStyles: StyleObject = {
  border: '2px dashed #ccc',
  backgroundColor: '#fafafa',
}

export const importInput__dropZoneDraggingStyles: StyleObject = {
  border: '2px dashed #007bff',
  backgroundColor: '#f8f9ff',
}

export const importInput__enhancedLabelStyles: StyleObject = {
  cursor: 'pointer',
  display: 'block',
  padding: '32px 16px',
  transition: 'background-color 0.2s ease-in-out',
  ':hover': {
    backgroundColor: '#f0f0f0',
  },
  ':active': {
    backgroundColor: '#e8e8e8',
  },
}

export const importInput__uploadIconStyles: StyleObject = {
  transition: 'transform 0.2s ease-in-out',
  ':hover': {
    transform: 'scale(1.1)',
  },
}

export const importInput__uploadDescStyles: StyleObject = {
  fontSize: '16px',
  fontWeight: '500',
  transition: 'color 0.2s ease-in-out',
}

export const importInput__uploadDescNormalStyles: StyleObject = {
  color: '#666',
}

export const importInput__uploadDescDraggingStyles: StyleObject = {
  color: '#007bff',
}

export const importInput__acceptedFormatsStyles: StyleObject = {
  fontSize: '12px',
  color: '#999',
  lineHeight: '1.4',
}

export const importInput__dropInstructionStyles: StyleObject = {
  fontSize: '11px',
  color: '#bbb',
  fontStyle: 'italic',
}
